<template>
  <div>

    <div class="kefu-fix" :class="{scrolling:scrollFlag}">
      <div style="float:left;width:70%;margin-top:40px">
        <div class="kefu-dis asc-line" v-if="isTis">
          <span> 有任何不明白的地方就来问我吧</span>
        </div>
        <!-- <img class="kefu-dis" src="/images/home/kefu-3.png" style="width:183px;height:33px;position:absolute;" alt=""> -->
      </div>
      <div style="float:right;width:20%;padding-left: 10px;" ref="shopBag">
        <div id="alldo" style="position:absolute;width:150px;height:150px;z-index:999;"></div>
        <img src="/images/home/kefu-1.png" style="width:42px;height:48px;position:absolute;margin-top:10px;margin-left:3px" class="kefu-baoblack" alt="">
        <img src="/images/home/kefu-2.png" style="width:56px;height:31px;position:absolute;margin-top: 43px;" class="kefu-ad" alt="">
      </div>
    </div>

    <van-popup v-model='wxShow'>
      <div class="myPopup">
        <img src="/images/home/kefu_weixin.png" class="img" />
        <img src="/images/home/newGift_close.png" @click="wxShow = false" class="close1" />
      </div>
    </van-popup>

  </div>
</template>

<script>
import publicObj from "../assets/js/public";
import zhugeObj from "@/assets/js/track";
var timerout;
import $ from "jquery";
export default {
  name: "rightKefuBtn",
  props: {},
  data() {
    return {
      scrollFlag: false,
      isTis: true,
      wxShow: false,
    };
  },
  computed: {},
  created() {},

  mounted() {
    if (localStorage.isKeFuShow) {
      this.isTis = false;
      setTimeout(() => {
        $(window).bind("scroll", () => {
          this.menu();
        });
      }, 1000);
    } else {
      setTimeout(() => {
        $(window).bind("scroll", () => {
          this.menu();
        });
        localStorage.isKeFuShow = 1;
      }, 4000);
    }
    this.addBuytton();
  },

  methods: {
    addBuytton() {
      var dom = document.getElementById("alldo"); //
      let urlend = encodeURIComponent(window.location.href);
      if (publicObj.isWeiXin()) {
        dom.innerHTML =
          '<wx-open-launch-weapp path="pages/kefu/index.html?h5Url=我正在浏览服务项：' +
          urlend +
          '" id="launch-btn"   username="gh_f36f18f6beed"><template><div style="width:100px;height:90px;"></div></template></wx-open-launch-weapp>';

        var launchBtn = document.getElementById("launch-btn");
        if (!launchBtn) {
          return;
        }
        launchBtn.addEventListener("launch", function (e) {
          zhugeObj.track({
            title: "服务详情页-客服按钮-点击",
          });
        });
        launchBtn.addEventListener("error", function (e) {
          console.log("fail", e.detail);
        });
      } else {
        dom.innerHTML = `<div style='width:100%;height:100%' id='kefuBtn'></div>`;
        var kefuBtn = document.getElementById("kefuBtn");
        kefuBtn.addEventListener("click", () => {
          this.wxShow = true
          zhugeObj.track({
            title: "创意改样—客服点击"
          });
        });
      }
    },

    menu() {
      this.scrollFlag = true;
      if (timerout) {
        window.clearTimeout(timerout);
      }
      timerout = window.setTimeout(() => {
        this.scrollFlag = false;
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  .img {
    width: 100%;
    display: block;
  }
}
.kefu-fix {
  width: 500px;
  height: 150px;
  // background-color: #7ADFDF;
  position: fixed;
  right: 0;
  bottom: 200px;
  right: 0 !important;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.asc-line {
  width: 0;
  height: 60px;
  position: relative;
  background: #000000;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  line-height: 60px;
  text-align: center;
  top: -14px;
  border-top-left-radius: 25px;
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
}
.kefu-dis {
  animation: myfirst 5s;
  animation-delay: 1s;
}
.kefu-ad {
  animation: mytwo 0.5s;
}
.kefu-baoblack {
  animation: mythree 1s;
}
@keyframes myfirst {
  0% {
    left: 385px;
    width: 0;
  }
  20% {
    left: 0px;
    width: 384px;
  }
  80% {
    left: 0px;
    width: 384px;
  }
  100% {
    left: 385px;
    width: 0;
  }
}
@keyframes mytwo {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}
@keyframes mythree {
  0% {
    margin-top: 48px;
  }
  90% {
    margin-top: 10px;
  }
}
.scrolling {
  right: -63px !important;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}

.van-popup {
  background: transparent;
}

.myPopup {
  width: 542px;
  margin: 0 auto;
  img {
    display: block;
    width: 542px;
  }
  .close1 {
    margin: 32px auto 0;
    display: block;
    width: 60px;
    height: 60px;
  }
}
</style>
